import { render } from "./Modal3.vue?vue&type=template&id=795322fe&scoped=true"
import script from "./Modal3.vue?vue&type=script&lang=js"
export * from "./Modal3.vue?vue&type=script&lang=js"

import "./Modal3.vue?vue&type=style&index=0&id=795322fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795322fe"]])

export default __exports__